import { Box, Typography } from '@mui/material';
import Iconify from './Iconify';
import '../css/noRecord.css';

const NoRecord = ({ description, buttonTitle, handleOpenDialog = () => { }, hasPermission = false }) => {
    return (
        <Box className='noRecord_main_box'>
            <img src="/EntireBrandmark.svg" alt="NoRecord logo" loading='lazy' decoding='async' />
            <Typography className='noRecord_description'>{description}</Typography>
            {hasPermission &&
                <Box className='noRecord_button' onClick={handleOpenDialog}>
                    <Iconify className='noRecord_icon' icon="material-symbols-light:add" />
                    <Typography>{buttonTitle}</Typography>
                </Box>
            }
        </Box>
    )
}

export default NoRecord